export type TextareaResize = 'none' | 'both' | 'horizontal' | 'vertical' | 'inherit'
